const theme = {
  color: {
    white: '#ffffff',
    lightGrey: '#ccc',

    primary: '#417ca5',
    primaryDark: '#405faf',
    primaryDarker: '#0c4287',
    primaryDarkest: '#031f73',
    primaryLight: '#ebeff7',
    primaryLighter: '#f4f4f4',
    primaryLightest: '#fcfcfc',

    secondary: '#43474d',
    secondaryDark: '#333333',
    get secondaryDarker() { return this.danger.secondaryDark; },
    secondaryDarkest: '#000',
    secondaryLight: '#666666',
    get secondaryLighter() { return this.danger.secondaryLight; },
    get secondaryLightest() { return this.danger.secondaryLight; },

    danger: '#c80000',
    get dangerDark() { return this.danger; },
    get dangerDarker() { return this.danger; },
    get dangerDarkest() { return this.danger; },
    get dangerLight() { return this.danger; },
    dangerLighter: '#fcdfdd',
    get dangerLightest() { return this.dangerLighter; },

    success: '#02a44a',
    get successDark() { return this.success; },
    get successDarker() { return this.success; },
    get successDarkest() { return this.success; },
    get successLight() { return this.success; },
    get successLighter() { return this.success; },
    get successLightest() { return this.success; },

    warning: '#ffe500',
    get warningDark() { return this.warning; },
    get warningDarker() { return this.warning; },
    get warningDarkest() { return this.warning; },
    get warningLight() { return this.warning; },
    warningLighter: '#ffffea',
    get warningLightest() { return this.warningLighter; },

    header: '#031f73',
    link: '#3455db',
    icons: '#3455db',

    bgItemLabel: '#F96302',
    fgItemLabel: '#fff',

    selected: {
      background: 'rgba(64, 95, 175, 0.125)',
    },
  },
  toggleSwitch: {
    checked: 'var(--green)',
    unchecked: 'var(--gray)',
  },
};
export default theme;
